import { useHistory } from "react-router-dom";
import { IconChevronLeft } from "@tabler/icons-react";
import KeyboardAvoidingView from "../../components/layout/KeyboardAvoidingView";
import { Button } from "../../components/ui/Button";
import Loader from "../../components/Loader";
import { OnboardingPublicationSearch } from "../../pages/onboarding/OnboardingPublicationSearch";
import { useCurrentUser } from "../../domains/user/hooks/useCurrentUser";
import { usePublicationSearchCompleted } from "../../domains/user/stores/publicationSearchStore";

export default function AuthorSearchPage(): React.JSX.Element {
  const history = useHistory();
  const { currentUser } = useCurrentUser();
  const [, setCompleted] = usePublicationSearchCompleted();

  if (currentUser === null) {
    return <Loader expanded />;
  }

  const firstName = currentUser.firstname === null ? "" : currentUser.firstname;
  const lastName = currentUser.lastname === null ? "" : currentUser.lastname;
  const specialtyTagId =
    currentUser.mainSpecialtyModel === null
      ? null
      : currentUser.mainSpecialtyModel.id;

  return (
    <KeyboardAvoidingView
      behavior="height"
      className="absolute inset-0 flex flex-col bg-[#fbfbfb]"
    >
      <div className="flex items-center justify-between px-6 pt-[max(env(safe-area-inset-top),20px)] pb-1 mt-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => {
            history.goBack();
          }}
          className="p-0 text-black size-7 shrink-0"
        >
          <IconChevronLeft className="size-full!" />
        </Button>
      </div>

      <div className="flex flex-1 flex-col px-5 pt-5 pb-6 overflow-hidden min-h-0">
        <OnboardingPublicationSearch
          firstName={firstName.trim()}
          lastName={lastName.trim()}
          specialtyTagId={specialtyTagId}
          searchPublications
          accountReady={Promise.resolve()}
          onPhaseChange={() => {}}
          onComplete={() => {
            setCompleted(true);
            history.replace("/discovery");
          }}
        />
      </div>
    </KeyboardAvoidingView>
  );
}
